import { useThrottledValue as useMantineThrottledValue } from '@mantine/hooks';

export const useThrottledValue = useMantineThrottledValue;
